module.exports = __webpack_public_path__ + "img/inactive-overlay.c5dd81ba.svg";